import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";

const CHART_TOOLTIP_STYLE = {
  background: "hsl(var(--card))",
  border: "1px solid hsl(var(--border))",
  color: "hsl(var(--foreground))",
};
const CHART_BAR_RADIUS = [4, 4, 0, 0];

export function UtilisationTab({ stats }) {
  return (
    <div className="card-tactical p-6 rounded-md">
      <div className="text-[10px] tracking-widest uppercase opacity-60 mb-4">Confirmed bookings (upcoming) per pitch</div>
      <div style={{ width: "100%", height: 288 }}>
        <ResponsiveContainer width="100%" height={288} minWidth={0} minHeight={240}>
          <BarChart data={stats.utilization}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(128,128,128,0.15)" />
            <XAxis dataKey="pitch" stroke="currentColor" opacity={0.6} fontSize={12} />
            <YAxis stroke="currentColor" opacity={0.6} fontSize={12} allowDecimals={false} />
            <Tooltip contentStyle={CHART_TOOLTIP_STYLE} />
            <Bar dataKey="bookings" fill="#83B68B" radius={CHART_BAR_RADIUS} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
